<template>
    <multiselect
            :clear-on-select="false"
            :close-on-select="true"
            :hide-selected="true"
            :internal-search="false"
            :limit="3"
            :loading="isLoading"
            :max-height="600"
            :options="units"
            :options-limit="300"
            :searchable="true"
            :selectLabel="''"
            :show-no-results="false"
            @input="onSelect()"
            @search-change="getUnits"
            id="unit"
            label="name"
            name="unitid"
            open-direction="bottom"
            placeholder="Search unit"
            track-by="id"
            v-model="unit">
        <template slot="singleLabel" slot-scope="props">
            {{props.option.name}}
        </template>
        <template slot="option" slot-scope="props">
            <div class="option__desc">
                <h5>{{ props.option.symbol }}</h5>
                <h5>{{ props.option.name }}</h5>
            </div>
        </template>
        <span slot="noResult">Unit not found</span>
    </multiselect>
</template>

<script>
    import Multiselect from 'vue-multiselect';

    export default {
        name: "UnitSelect",
        props: {},
        components: {Multiselect},
        data() {
            return {
                isLoading: false,
                unit: null,
                units: []
            }
        },
        methods: {
            async getUnits(searchText) {
                this.isLoading = true;
                let row        = await this.$http.get('unit/search', {
                    params: {
                        search: searchText
                    }
                });
                this.units     = row.data;
                this.isLoading = false;
            },
            onSelect() {
                this.$emit('unit-select', this.unit);
            }
        }
    }
</script>

<style scoped>

</style>
